const NAME = "REQUESTS_PAGE";

export default NAME;
